import React, {useEffect, useState} from "react";
import {Dialog} from "primereact/dialog";
import Button from "../common/botton/Button";

export default function CookiesDialog(props) {

    const [acceptedCookie, setAcceptedCookie] = useState(localStorage.getItem("acceptedCookie"));
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if(acceptedCookie === "true") {
            localStorage.setItem("acceptedCookie", "true")
            setVisible(false)
        } else if(acceptedCookie === "false") {
            localStorage.setItem("acceptedCookie", "false")
            if(window.location.pathname === "/impressum" || window.location.pathname === "/datenschutz"){
                setVisible(false)
            }
        } else {
            localStorage.setItem("acceptedCookie", "null")

            setVisible(true)
            /*
            if(window.location.pathname === "/impressum" || window.location.pathname === "/datenschutz"){
                setVisible(false)
            } else {

            }

             */
        }
    }, [acceptedCookie]);

    return (
        <React.Fragment>
            {visible && (
                <React.Fragment>
                    <div style={{position: 'fixed', background: 'transparent' , height: '100px', width: '100%', zIndex: 9999}}></div>
                    <div style={{position: 'fixed', background: 'transparent' , height: '100px', width: '100%', zIndex: 9999, bottom: 0}}></div>
                </React.Fragment>
            )}
            <Dialog

                modal={true}
                contentStyle={{borderRadius: '2rem', background: '#f3f8ff'}}
                showHeader={false}
                visible={visible}
                closeOnEscape={false}
                style={{ maxWidth: '300px', maxHeight: 'calc(100vh - 100px)' }} onHide={() => {setAcceptedCookie(null)}}>

                <h1>Nutzung von Cookies</h1>

                <div>
                    Wir verwenden Cookies, um das bestmögliche Nutzererlebnis zu bieten und unsere Bildungsangebote kontinuierlich zu verbessern.
                </div>

                <br/>
                <br/>
                <Button label="Akzeptieren" onClick={() => setAcceptedCookie("true")}/>
                <br/>
                <Button label="nur Notwendige" onClick={() => setAcceptedCookie("false")} style={{background: 'gray', border: '1px solid darkgray'}}/><table style={{width: '100%'}}/>
                <br/>
                <br/>
                <table>
                <tbody>
                <tr>
                    <td style={{width: '50%'}}></td>
                    <td>
                        <span onClick={() => window.location.href = "/datenschutz"}>Datenschutz</span>
                    </td>
                    <td>•</td>
                    <td>
                        <span onClick={() => window.location.href = "/impressum"}>Impressum</span>
                    </td>
                    <td style={{width: '50%'}}></td>
                </tr>
                </tbody>
                </table>

            </Dialog>
        </React.Fragment>
    )
}